







import BreadCrumbData from '@/modules/common/components/breadcrumb/breadcrumbData'
import Component from 'vue-class-component'
import page from '@/modules/common/components/page.vue'
import Vue from 'vue'
import workRecordsActivitySummaryTable from '@/modules/work/record/components/workRecordsActivitySummaryTable.vue'

@Component({
  components: { page, workRecordsActivitySummaryTable }
})
export default class WorkRecordsPersonalPage extends Vue {
  breadCrumbData = new BreadCrumbData([{ textKey: 'work-record.label' }, { textKey: 'work-record.summary.period.label' }])
}
